<template>
  <div>
    <card>
      <div slot="header">
        <l-button type="info"  @click="handlenew()">新增</l-button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <el-table-column prop="id" label="ID">
              <div slot-scope="props">
                <b class="font-weight-light">{{props.row.id}}</b>
              </div>
            </el-table-column>
            <el-table-column prop="userName" label="使用者帳號" />
            <el-table-column prop="nickname" label="使用者名稱" />
            <el-table-column prop="userGroupId" :formatter="getUserGroupsName" label="群組名稱" />
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs"
                  @click="handleEdit(props.row)"
                  v-show="props.row.id !== 1">
                  <i class="fa fa-edit" />
                </a>
                <a v-tooltip.top-center="''" class="btn btn-danger btn-link btn-xs"
                   @click="handleSwitchDisable(props.row.id, props)"
                   v-show="cuser !== null && props.row.id !== cuser.id">
                  <i class="fa fa-ban" :style="(props.row.isDisable)?'color:red':'color:grey'" />
                </a>
              </div>
            </el-table-column>
          </el-table>
          <div class="col-md-3">
            <el-dialog
              center
              :title="getTitle()"
              :visible.sync="modals.custom">
              <fg-input label="使用者帳號"
                        type="text"
                        name="userName"
                        data-vv-as="使用者帳號"
                        v-model="form.userName"
                        v-validate="'required'"
                        :disabled="form.id !== ''"      
                        :error="getError('userName')"
                        required />
              <fg-input label="使用者名稱"
                        type="text"
                        name="nickname"
                        placeholder="ssss"
                        data-vv-as="使用者名稱"
                        v-model="form.nickname"
                        :error="getError('nickname')"
                        v-validate="'required'"
                        required />
              <fg-input label="密碼"
                        type="password"
                        name="password"
                        data-vv-as="密碼"
                        v-model="form.password"
                        :error="getError('password')"
                        v-validate="(form.id === '')?'required|min:8|max:20':'min:8|max:20'"
                        required />
              <div class="form-group align-left">
                <label>使用者群組 *</label>
                <el-select class="select-default" data-vv-as="使用者群組" placeholder="請選擇" name="userGroupId" v-model="form.userGroupId" :error="getError('userGroupId')"  v-validate="'required'" >
                    <el-option v-for="i in userGroups" class="select-default" :value="i.id" :label="i.name" :key="i.id" />
                </el-select>
                <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('userGroupId')">{{ errors.first('userGroupId') }}</div>
              </div>
              <div class="text-right">
                <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>


<script>
 /* eslint-disable */ 
  import { Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import { Checkbox } from 'src/components/index'
  import lib from '../../lib'
  import tools from '../../tools'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox
    },
    data() {
      return {
        form: {
          id: '',
          nickname: null,
          userName: null,
          password: null,
          userGroupId: null
        },
        userGroups:[],
        cuser: null,
        modals: {
          custom: false,
        },
        tableData: []
      }
    },
   async mounted() {
      await this.getGroupData()
      await this.getData()
      this.cuser = lib.getUser()
    },
    methods: {
      async getGroupData() {
        var data = await lib.getUserGroups()
        if (data.status == 0) {
          var result = data.result
          this.userGroups = result.userGroups
        }
      },
      getUserGroupsName(row, idx) {
        var userGroupId = row.userGroupId
        for (var i=0 ; i < this.userGroups.length ; i++) {
          if (this.userGroups[i]['id'] == userGroupId) {
            return this.userGroups[i]['name']
          }
        }
        return ''
      },
      getTitle() {
        return (this.form.id == '')?'新增使用者':'編輯使用者'
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return;
          if (this.form.id === '') {
            _this.createUser()
          } else {
            _this.updateUser(this.form)
          }
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          _this.form.id = ''
          _this.form.userName = ''
          _this.form.nickname = ''
          _this.form.password = ''
          _this.form.userGroupId = ''
          resolve()
        })
      },
      async handlenew() {
        await this.clearForm();
        this.$validator.errors.clear()
        this.openModal('custom')
      },
      handleEdit(row) {
        this.form.id = row.id
        this.form.userName = row.userName
        this.form.nickname = row.nickname
        this.form.password = ''
        this.form.userGroupId = row.userGroupId
        this.openModal('custom')
      },
      handleDelete(index, row) {
        alert(`Your want to delete ${row.name}`)
      },
      async getData() {
        var data = await lib.getUserList()
        if (data.status == 0) {
          var result = data.result
          this.tableData = result.users
        }
      },
      async updateUser(form) {
        var data = await lib.updateUser(this.form.id, form)
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('已更新', '', 'success')
        }
      },
      async createUser() {
        var data = await lib.createUser(this.form)
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('新增成功', '', 'success')
        } else if (data.status == 101) {
          this.$swal('使用者帳號已經被使用', '', 'error')
        } else {
          this.$swal('新增失敗', '', 'error')
        }
      },
      async handleSwitchDisable(id, porp) {
        var isDisable = porp.row.isDisable
        var result = await tools.confirmDialog(this, `確定要${(isDisable)?'啟用':'停用'}此帳號?`)
        if (result) {
          var set = !isDisable
          var data = await lib.updateUser(id, {isDisable : set})
          if (data.status == 0) {
            this.tableData[porp.$index].isDisable = set
            this.$notify(
            {
              message:`帳號 ${porp.row.userName} 已${(isDisable)?'重新啟用':'停用'}`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "danger"
            })
          } else {
            // this.$swal('刪除失敗', '', 'error')
          }
        }
      }
    }
  }
</script>
